// // components/Header.tsx
// 'use client'

// import { Search, Bell, LogOut } from 'lucide-react'
// import { useState } from 'react'
// import { useAuth } from '@/context/AuthContext'

// interface HeaderProps {
//   title?: string;
//   showActions?: boolean;
// }

// const Header = ({ title = "Dashboard Overview", showActions = true }: HeaderProps) => {
//   const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
//   const { user, logout } = useAuth()

//   const handleLogout = async (): Promise<void> => {
//     try {
//       await logout()
//     } catch (error) {
//       console.error('Logout error:', error)
//     } finally {
//       setShowLogoutConfirm(false)
//     }
//   }

//   return (
//     <>
//       <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 sm:px-8 shrink-0 z-10 sticky top-0">
//         <h1 className="text-xl font-bold text-slate-800">{title}</h1>
        
//         {showActions && (
//           <div className="flex items-center gap-4">
//             <div className="hidden md:flex relative">
//               <input 
//                 className="pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary w-64 bg-slate-50"
//                 placeholder="Search..."
//                 type="text"
//               />
//               <Search size={18} className="absolute left-3 top-2.5 text-slate-400" />
//             </div>
            
//             <button className="size-9 flex items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors relative">
//               <Bell size={20} />
//               <span className="absolute top-2 right-2 size-2 bg-red-500 rounded-full border-2 border-white"></span>
//             </button>
            
//             <div className="flex items-center gap-3">
//               <div className="text-right hidden sm:block">
//                 <p className="text-sm font-semibold text-slate-800">{user?.name}</p>
//                 <p className="text-xs text-slate-500 capitalize">{user?.role}</p>
//               </div>
//               <button 
//                 onClick={() => setShowLogoutConfirm(true)}
//                 className="flex items-center gap-2 text-slate-600 hover:text-primary px-3 py-2 rounded-lg hover:bg-slate-50 transition-colors text-sm font-semibold"
//               >
//                 <LogOut size={18} />
//                 <span className="hidden sm:inline">Logout</span>
//               </button>
//             </div>
//           </div>
//         )}
//       </header>

//       {/* Logout Confirmation Modal */}
//       {showLogoutConfirm && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-xl max-w-md w-full">
//             <div className="p-6">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="p-2 bg-blue-100 text-primary rounded-lg">
//                   <LogOut size={24} />
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-slate-800">Logout Confirmation</h3>
//                   <p className="text-sm text-slate-500">Are you sure you want to logout?</p>
//                 </div>
//               </div>

//               <div className="flex gap-3 mt-6">
//                 <button
//                   onClick={() => setShowLogoutConfirm(false)}
//                   className="flex-1 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleLogout}
//                   className="flex-1 rounded-lg bg-primary hover:bg-primary-dark text-white px-4 py-3 text-sm font-semibold"
//                 >
//                   Yes, Logout
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   )
// }

// export default Header

// components/Header.tsx
'use client'

import { Search, Bell, LogOut } from 'lucide-react'
import { useState } from 'react'
import { useAuth } from '@/context/AuthContext'
import ReportsDropdown from './ReportsDropdown'

interface HeaderProps {
  title?: string;
  showActions?: boolean;
}

const Header = ({ title = "Dashboard Overview", showActions = true }: HeaderProps) => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
  const { user, logout } = useAuth()

  const handleLogout = async (): Promise<void> => {
    try {
      await logout()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      setShowLogoutConfirm(false)
    }
  }

  return (
    <>
      <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 sm:px-8 shrink-0 z-10 sticky top-0">
        <h1 className="text-xl font-bold text-slate-800">{title}</h1>
        
        {showActions && (
          <div className="flex items-center gap-4">
            <div className="hidden md:flex relative">
              <input 
                className="pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary w-64 bg-slate-50"
                placeholder="Recherche..."
                type="text"
              />
              <Search size={18} className="absolute left-3 top-2.5 text-slate-400" />
            </div>
            
            {/* Add Reports Dropdown Here */}
            <ReportsDropdown className="hidden md:flex" />
            
            <button className="size-9 flex items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors relative">
              <Bell size={20} />
              <span className="absolute top-2 right-2 size-2 bg-red-500 rounded-full border-2 border-white"></span>
            </button>
            
            <div className="flex items-center gap-3">
              <div className="text-right hidden sm:block">
                <p className="text-sm font-semibold text-slate-800">{user?.name}</p>
                <p className="text-xs text-slate-500 capitalize">{(user?.role)?.replace(/_/g, ' ')}</p>
              </div>
              <button 
                onClick={() => setShowLogoutConfirm(true)}
                className="flex items-center gap-2 text-slate-600 hover:text-primary px-3 py-2 rounded-lg hover:bg-slate-50 transition-colors text-sm font-semibold"
              >
                <LogOut size={18} />
                <span className="hidden sm:inline">Déconnexion</span>
              </button>
            </div>
          </div>
        )}
      </header>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-md w-full">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-blue-100 text-primary rounded-lg">
                  <LogOut size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-800">Confirmation de déconnexion</h3>
                  <p className="text-sm text-slate-500">Êtes-vous sûr de vouloir vous déconnecter ?</p>
                </div>
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => setShowLogoutConfirm(false)}
                  className="flex-1 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50"
                >
                  Annuler
                </button>
                <button
                  onClick={handleLogout}
                  className="flex-1 rounded-lg bg-primary hover:bg-primary-dark text-white px-4 py-3 text-sm font-semibold"
                >
                  Oui, se déconnecter
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Header